import React from 'react';
import {Helmet} from "react-helmet";
import {useQueryClient} from "@tanstack/react-query";
import {USER_CURRENT_KEY} from "../../../api/public-voissa/users";
import { useLocation } from 'react-router-dom';

import "./HomeFeed.scss";

import {canonical} from "../../../libs/helper";

import {useBreakpoint} from "../../../libs/breakpoint";
import FeedProfilesSuggest from './components/FeedProfilesSuggest';
import HomeFeedDefaultPopular from './HomeFeedDefaultPopular';
import HomeFeedForYou from './HomeFeedForYou';
import HomeFeedMostRecent from './HomeFeedMostRecent';
import TabNav, { TabNavItem, TabTitle } from '../../components2/TabNav/TabNav';
import FooterDescribe from '../../components2/FooterDescribe/FooterDescribe';

const TAB = {
    DISCOVER : <HomeFeedDefaultPopular/>,
    FOR_YOU : <HomeFeedForYou/>,
    RECENT : <HomeFeedMostRecent/>,
}

const HomeFeed = () =>{
    const breakpoints = useBreakpoint();
    const queryClient = useQueryClient();
    const userIsConnected = !!queryClient.getQueryData([USER_CURRENT_KEY]);
    const defaultTab = userIsConnected ? 'FOR_YOU' : 'DISCOVER';
    const location = useLocation();
    const hash = location.hash;
    let currentTab;
    switch (hash) {
        case '#suivis':
            currentTab = 'FOR_YOU';
            break;
        case '#decouvrir':
            currentTab = 'DISCOVER';
            break;
        case '#plus-recents':
            currentTab = 'RECENT';
            break;
        default:
            currentTab = defaultTab;
    }
    const feedTabRender = TAB[currentTab] || TAB['DISCOVER'];
    return (
        <div id="HomeFeed">
            <Helmet>
                <title>Voissa : Révélez-vous !</title>
                <meta name="description"
                      content={"Voissa est un espace unique où chacun peut partager ses contenus intimes, s'exprimer librement et explorer sa sexualité. Plus qu'un réseau social sans censure, c'est un lieu de découverte et de rencontre où vous pouvez aussi simplement admirer le contenu partagé par d'autres. Chez Voissa, vous définissez vos propres limites, que vous soyez acteur ou spectateur."}/>
                <meta name="keywords"
                      content={"voissa, sexe amateur, video amateur, video sexe amateur, amateur sexe"}/>
                <link rel="canonical" href={canonical("", "", "home")} />
            </Helmet>
            <div className="container">
                <div className='hf-layout'>
                    <div className="hf-main-wrapper">
                        <div className="hf-feed-wrapper">
                            <TabNav sticky autoHide={breakpoints.md}>
                                {userIsConnected &&  <TabNavItem isLink={true} to="#suivis" active={currentTab === 'FOR_YOU'}>Suivis</TabNavItem>}
                                <TabNavItem isLink={true} to="#decouvrir" active={currentTab === 'DISCOVER'}>Découvrir</TabNavItem>
                                <TabNavItem isLink={true} to="#plus-recents" active={currentTab === 'RECENT'}>Plus récents</TabNavItem>
                            </TabNav>
                            {feedTabRender}
                        </div>
                    </div>
                    {!breakpoints.md && (
                        <div className="hf-side-wrapper">
                            <div className="hf-side-sticky-wrapper">
                                <TabTitle sticky>
                                    Suggestion de profils
                                </TabTitle>
                                <FeedProfilesSuggest/>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            {!userIsConnected && (
                <div className="container">
                    <FooterDescribe kind="home"/>
                </div>
            )}
        </div>
    );
}

export default HomeFeed